
























import { Component, Vue } from 'vue-property-decorator';

@Component({
  name: 'dn-loader',
})
export default class Loader extends Vue {}
